import { useEffect, useState } from 'react';
import { resolveMediaUrl } from '@/api/request';

interface AvatarProps {
  src?: string | null;
  name?: string;
  size?: number | 'sm' | 'md' | 'lg' | 'xl';
  color?: 'blue' | 'orange' | 'green' | 'purple' | 'red' | 'gradient';
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
}

const sizeMap = {
  sm: 28,
  md: 36,
  lg: 48,
  xl: 80
};

const colorMap = {
  blue: 'linear-gradient(135deg, #F9EBD6, #ECD4AE)',
  orange: 'linear-gradient(135deg, #F4DFC0, #E9C68F)',
  green: 'linear-gradient(135deg, #E1E9D9, #B9CFAC)',
  purple: 'linear-gradient(135deg, #EBDDD0, #D6BA9E)',
  red: 'linear-gradient(135deg, #F2D6CE, #DFA89A)',
  gradient: 'linear-gradient(135deg, #F9EBD6, #ECD4AE)'
};

export default function Avatar({
  src,
  name = '',
  size = 'md',
  color = 'blue',
  style,
  className = '',
  onClick
}: AvatarProps) {
  const pixelSize = typeof size === 'number' ? size : sizeMap[size];
  const initial = name ? name.charAt(0) : '';
  const resolvedSrc = resolveMediaUrl(src);
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const showImage = Boolean(resolvedSrc && failedSrc !== resolvedSrc);

  const fontSize = pixelSize * 0.4;

  useEffect(() => {
    setFailedSrc(null);
  }, [resolvedSrc]);

  return (
    <div
      className={`ios-avatar ${className}`}
      onClick={onClick}
      style={{
        width: pixelSize,
        height: pixelSize,
        fontSize,
        background: colorMap[color],
        color: showImage ? undefined : '#513727',
        boxShadow: pixelSize >= 48 ? '0 4px 16px rgba(57, 40, 28, 0.10)' : 'none',
        cursor: onClick ? 'pointer' : 'default',
        ...style
      }}
    >
      {showImage ? (
        <img
          src={resolvedSrc}
          alt={name ? `${name}的头像` : '头像'}
          onError={() => setFailedSrc(resolvedSrc || null)}
        />
      ) : initial}
    </div>
  );
}
